import React from 'react';
import {useForm} from 'react-hook-form';

import {FieldError, Input, Label} from '@design-system';

import {useAuth} from '../Auth/useAuth';
import ProAccountFieldEdit from './ProAccountFieldEdit';

const JOB_TITLE_ID = 'pro-account-job-title';
const ERROR_ID = `${JOB_TITLE_ID}-error`;

const ProAccountJobTitle = () => {
  const {authState, updateProfessionalProfile} = useAuth();
  const onSubmit = (data) => updateProfessionalProfile({...authState.user.profile, ...data});
  const {
    register,
    handleSubmit,
    formState: {errors},
  } = useForm();

  return (
    <ProAccountFieldEdit handleSubmit={handleSubmit} onSubmit={onSubmit} buttonDisabled={false}>
      <Label htmlFor={JOB_TITLE_ID} className="mb-1 block">
        Job Title
      </Label>
      <Input
        id={JOB_TITLE_ID}
        className="h-11"
        aria-invalid={errors.job_title ? true : undefined}
        aria-describedby={errors.job_title ? ERROR_ID : undefined}
        {...register('job_title', {required: true, value: authState.user.profile.job_title})}
      />
      <FieldError id={ERROR_ID}>{errors.job_title && 'Please enter your job title.'}</FieldError>
    </ProAccountFieldEdit>
  );
};

export default ProAccountJobTitle;
